import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-step-presentata',
  template: `

<div class="flex flex-col bg-white border shadow-sm rounded-xl mt-6">
  <div class="flex flex-row justify-between bg-primary border-b rounded-t-xl py-3 px-4 md:py-4 md:px-5">
    <p class=" text-white">
    {{ props.label }}
    </p>

  </div>
  <div class="p-4 md:p-5">
    <p class="mt-2 flex w-full p-4 justify-start">
      <ng-container #fieldComponent></ng-container>
    </p>

    <!--
    <div class="bg-green-100 border border-green-200 text-sm text-green-800 rounded-lg p-4 dark:bg-teal-800/10 dark:border-teal-900 dark:text-teal-500" role="alert">
     Domanda arrivata in attesa di assegnazione
    </div>
-->

  </div>

</div>
  `,
  standalone: true,
  imports: [FormlyModule, MatIconModule]
})
export class PanelPresentataComponent extends FieldWrapper {
}
